// src/index.tsx

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

// Define your base URL here
const baseName = '/'; // Replace with your actual base URL, e.g., '/my-app'

const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <Router basename={baseName}>
            <App />
        </Router>
    </React.StrictMode>
);
